<template>
 
   <div  >



<div v-if='addbox'  style=" position: fixed;top:0;bottom: 0;left: 0;right: 0;" class="logbox d-flex justify-content-center">
  <div style="position:absolute;top:0;bottom: 0;left: 0;right: 0;background:rgba(0,0,0,0.3);cursor:pointer" v-on:click='closeaddbox'></div>
  <div style="width:670px;position:relative;z-index:100000000;">
        
        <div style="padding:33px" class="loginwrapper">

            <form  v-on:submit.prevent='addaddress'>
              <div class="d-flex align-items-center justify-content-between">
                <p style="color:#1a181e;font-size: 18px;font-weight: 500;">Add new address</p>
                <i class='bx bx-x' style="color:#4d4d4d;font-size:30px;cursor:pointer" v-on:click='closeaddbox'></i>
              </div>


              <div class="pt-2">
                
                <div class="d-flex align-items-start  " style="margin-top:25px">
                  
                  <div style="width:50%;padding-right:10px">
                    <p style="color:#808080;margin-bottom:10px;font-size:14px;font-weight:300;font-family: 'Roboto', sans-serif!important" >Name</p>
                    <div style="border:1px solid #d9d9d9;border-radius:3px;">
                      <input required=""  type="text" class="form-control" placeholder="Enter name" style="font-size:16px;color:#1a181e;    height: 45px;;font-weight:300" v-model='addrnames' name="">
                    </div>
                    
                  </div>
                   <div style="width:50%;padding-left:10px">
                     <p style="color:#808080;margin-bottom:10px;font-size:14px;font-weight:300;font-family: 'Roboto', sans-serif!important">Mobile Number</p>
                    <div style="border:1px solid #d9d9d9;border-radius:3px;">
                      <input required=""  type="text" class="form-control" placeholder="Enter mobile number" style="font-size:16px;color:#1a181e;    height: 45px;;font-weight:300"  v-model='addrmobile' name="">
                    </div>
                  </div>
                </div>

                <div class="d-flex align-items-start" style="margin-top:30px">
                  
                  <div style="width:50%;padding-right:10px">
                    <p style="color:#808080;margin-bottom:10px;font-size:14px;font-weight:300;font-family: 'Roboto', sans-serif!important">Pincode</p>
                    <div style="border:1px solid #d9d9d9;border-radius:3px;">
                      <input required=""  type="text" class="form-control" v-model='addrpincode' placeholder="Enter pincode" style="font-size:16px;color:#1a181e;    height: 45px;;font-weight:300" name="">
                    </div>
                    
                  </div>
                   <div style="width:50%;padding-left:10px">
                     <p style="color:#808080;margin-bottom:10px;font-size:14px;font-weight:300;font-family: 'Roboto', sans-serif!important">City</p>
                    <div style="border:1px solid #d9d9d9;border-radius:3px;">
                      <input required=""  type="text" class="form-control" placeholder="Enter city" v-model='addrcity' style="font-size:16px;color:#1a181e;    height: 45px;;font-weight:300" name="">
                    </div>
                  </div>
                </div>
                 <div class="d-flex align-items-start" style="margin-top:30px">
                  
                  
                   <div style="width:100%;padding-left:0px">
                     <p style="color:#808080;margin-bottom:10px;font-size:14px;font-weight:300;font-family: 'Roboto', sans-serif!important">Address</p>
                    <div style="border:1px solid #d9d9d9;border-radius:3px;">
                      <textarea required=""  type="text" class="form-control" placeholder="Enter city" v-model='addraddress' style="font-size:16px;color:#1a181e;    height: 45px;;font-weight:300;min-height:80px" name=""></textarea>
                    </div>
                  </div>
                </div>
              </div>



 

                   

 
                              <div class="d-flex align-items-center justify-content-center">

                                <button v-if='!edit'   class="btn loggrn" style=" font-size: 14px;font-weight: 600;color: #fff;  background:#146eb4;padding:12px 20px;margin-top:30px;font-size:15px;cursor:pointer "   >Add Address</button>
                                   <button v-else class="btn loggrn" style=" font-size: 14px;font-weight: 600;color: #fff;  background:#146eb4;padding:12px 20px;margin-top:30px;font-size:15px;cursor:pointer "   >Edit Address</button>
                              
                               
                              </div>
                              

            </form>
          
        </div>
    
  </div>


</div>












<div v-if='deletebox'  style=" position: fixed;top:0;bottom: 0;left: 0;right: 0;" class="logbox d-flex justify-content-center">
  <div style="position:absolute;top:0;bottom: 0;left: 0;right: 0;background:rgba(0,0,0,0.3);cursor:pointer" v-on:click='deletebox=false'></div>
  <div style="width:360px;position:relative;z-index:100000000;">
        
        <div style="padding:33px" class="loginwrapper">

            
              <div class="d-flex align-items-center justify-content-between">
                <p style="color:#1a181e;font-size: 18px;font-weight: 500;">Delete this address?</p>
                <i class='bx bx-x' style="color:#4d4d4d;font-size:30px;cursor:pointer" v-on:click='deletebox=false'></i>
              </div>


                              <div class="d-flex align-items-center justify-content-center">

                                <button v-on:click='finaldelete'    class="btn loggrn" style=" font-size: 14px;font-weight: 600;color: #fff;  background:#E63631;padding:9px 25px;margin-top:30px;font-size:15px;cursor:pointer "  >Delete</button>
                                 
                              </div>
                              


             



 

                   

  

         
          
        </div>
    
  </div>


</div>










<div v-if='loginbox'  style=" position: fixed;top:0;bottom: 0;left: 0;right: 0;" class="logbox d-flex justify-content-center">
  <div style="position:absolute;top:0;bottom: 0;left: 0;right: 0;background:rgba(0,0,0,0.3);cursor:pointer" v-on:click='loginbox=false'></div>
  <div v-if="logintype=='send'" style="width:470px;position:relative;z-index:100000000">
        
        <div style="" class="loginwrapper">

            <form  v-on:submit.prevent='login'>
              <div class="d-flex align-items-center justify-content-between mt-md-0 mt-3">
                <p style="font-size: 18px;
    font-weight: 700;
    color: rgb(11, 10, 35);">Enter Mobile Number</p>
                <i class='bx bx-x' style="    color: rgb(11, 10, 35);
    font-size: 25px;
    cursor: pointer !important;" v-on:click='closeloginbox'></i>
              </div>


                            <div style="position: relative;    background: #FFFFFF!important;
    border: 1px solid #E7E5F2!important;
    border-radius: 5px;!important" class='labhead  d-flex align-items-center '  id="hideinputl">
                              <p style="padding-left:10px;color:rgb(11, 10, 35);font-weight:600" class="p91">+91 </p><span style="height:50px;width:1px;background:rgb(231 229 242 / 60%);margin:0px 15px;"></span>
                              
                              <div style="flex:1" class="d-md-block d-none">
                                
                        
                            <input autofocus=""  type="text" placeholder="Enter your mobile number" name="phone" class="logininput loginin"   required="" v-model='phone' minlength="10" maxlength="10">
                           
                                  </div>


                                     

                                      <div style="flex:1;position:relative" class="d-md-none d-block">
                                
                         
                             <input  autofocus=""  type="number" id="phonenumber" placeholder="Enter your mobile number"  name="phone" class="logininput loginin"   required="" v-model='phone' minlength="10" maxlength="10">
 
                    
                           
                                  </div>




                        





                          </div>
                              <div id="recaptcha-container"></div>

                   

 
                              <div class="d-flex align-items-center justify-content-center martp" style="" >

                                <button    class="btn loggrn" style=" font-size: 14px;font-weight: 600;color: #fff;  background:#EB3838;padding:12px 20px;font-size:15px;cursor:pointer " v-if='phone.length==10'  >Send Otp</button>
                                <button disabled=""  class="btn loggrn" style=" font-size: 14px;font-weight: 600;color: #fff;  background:#EB3838;padding:12px 20px; font-size:15px;cursor:pointer "   v-if='phone.length!=10' >Send Otp</button>
                              </div>
                              

            </form>
          
        </div>
    
  </div>











  <div v-if="logintype=='otp'" style="width:500px;position:relative;z-index:100000000">
        
        <div  class="loginwrapper">

            

              <div class="d-flex align-items-center justify-content-between  mar40"  >

                 <p style="font-size: 18px;
    font-weight: 700;
    color: rgb(11, 10, 35);">OTP Verification</p>
                <i class='bx bx-x' style="    color: rgb(11, 10, 35);
    font-size: 25px;
    cursor: pointer !important;" v-on:click='closeloginbox'></i>



               
              </div>

                      
       

            <div  class="otpboxes  " style="">
    <v-otp-input
      inputClasses="otp-input"
      :numInputs="6"
       separator=""
      :shouldAutoFocus="true"
                 @on-complete="subotp"
       
    />
  </div>
                           

                     
 

<div class="d-flex align-items-center justify-content-center">
  

      <button   class="btn loggrn" style=" font-size: 14px;font-weight: 600;color: #fff;  background:#EB3838;padding:12px 20px; font-size:15px;cursor:pointer " v-on:click='subotps'   v-if='otpenterd' >Login</button>
      </div>
 

  <p v-if='perrs' style="text-align:center;color:red">{{otptext}}</p>
 
                      
 
                              

       
          
        </div>
    
  </div>




</div>




<!--
 
  
   <div v-if='!loadstatus' style="z-index:100000000000000;position:fixed;top:0;left:0;right:0;bottom:0;background:rgba(0,0,0,.3)" class="d-flex align-items-center justify-content-center">
   
   <div style="width:100px;">
     <img src="https://shop.websitelearners.com/static/img/loader.0395a07.gif" class="img-fluid" style="width:100%">
   </div>
 </div>


-->



  <div  >
 
<div  style="" class="heads"> 



 

 




<div style="z-index: 10000;position: fixed;bottom: 0;left: 0;right: 0;padding:10px 27px;background: #fff;box-shadow:rgb(0 0 0 / 20%) 0px 2px 4px -1px, rgb(0 0 0 / 14%) 0px 4px 5px 0px, rgb(0 0 0 / 12%) 0px 1px 10px 0px" class="d-md-none d-flex align-items-center justify-content-between">


  






  <div
 
v-bind:class="[{ botactive: $route.path.toLowerCase()=='/'+info.name.toLowerCase()},{ botnotactive: $route.path.toLowerCase()!='/'+info.name.toLowerCase() },{navclass:true}]"  >


    <router-link to='/' style='text-decoration:none'>

 <img src="./images/files/homeblack.svg" style="transform:translateY(-1px)" >



</router-link>
</div>


 
 





   <div  class="botnotactive navclass"   style="position:relative">
    <router-link to='/bag' style='text-decoration:none'>

<div style="width:16px;height:16px;background:#EB3838;border-radius:50%; z-index:10000;   position: absolute;
    top: 3px;
    right: 4px;" class="d-flex align-items-center justify-content-center" v-if='carts.length'>
  <span style="margin:0!important;color:#fff;font-size:10px;font-weight:700">{{rendercartlength}}</span>
</div>
 <img src="./images/files/bagbottom.svg"  style="width:20px;transform:translateY(-1px)" >

  </router-link>
  </div>




   <div   class="botactive navclass"   v-on:click='account'>
        

 <img src="./images/files/userwhite.svg" style="width:20px;transform:translateY(-1px)"   >
 
  </div>
   
</div>



<!-- heaaderr -->




 
<div  class="  pt-md-4 pb-md-4 pt-3 pb-3  headerwrapper" style="position:sticky;top:0px;background:#fff;z-index:10000000">
  <div class="container  ">

  <div class="headerui     ">
    <router-link  to="/" style='text-decoration:none'>
<div class="d-flex align-items-center mr-4  logowrapper">
  
  <img src="./images/finallogo.png" style="" class="logohigh">
</div>
</router-link>
 






<div class="d-flex align-items-center  navwrapper  ml-3   ">
  

  <div class="d-none align-items-center contactwhatsapp" style="">
    
    <img src="https://cdn.usbrandcolors.com/images/logos/whatsapp-logo.svg" style="width:20px;margin-right:6px;min-width:20px;">

 <p style="font-weight:600;color:#fff;font-size:13px">WhatsApp</p>

  </div>


 
  <router-link    to="/bag"  style='text-decoration:none'>
  <div class="d-flex align-items-center navitem pl-4 ml-4" style="position:relative;margin-left:30px">
    
          <div style="position:absolute;left:0;height:20px;width:1px;background:#e8e9f1;opacity:0.4"></div>


    <div style="width:16px;height:16px;background:#EB3838;border-radius:50%;    position: absolute;
    top: 2px;
    right: 10px;" class="d-flex align-items-center justify-content-center" v-if='carts.length'>
  <span style="margin:0!important;color:#fff;font-size:11px;font-weight:600">{{rendercartlength}}</span>
</div>



 <svg width="17" height="20" viewBox="0 0 17 20" fill="#0B0A23" xmlns="http://www.w3.org/2000/svg">
<path opacity="0.7" d="M15 5.83333H11.6667V3.33333C11.6667 1.4925 10.1742 0 8.33333 0C6.4925 0 5 1.4925 5 3.33333V5.83333H1.66667L0 20H16.6667L15 5.83333ZM5.83333 3.33333C5.83333 1.955 6.955 0.833333 8.33333 0.833333C9.71167 0.833333 10.8333 1.955 10.8333 3.33333V5.83333H5.83333V3.33333ZM5 7.5V8.75C5 8.98 5.18667 9.16667 5.41667 9.16667C5.64667 9.16667 5.83333 8.98 5.83333 8.75V7.5H10.8333V8.75C10.8333 8.98 11.02 9.16667 11.25 9.16667C11.48 9.16667 11.6667 8.98 11.6667 8.75V7.5H13.5183L13.9108 10.8333H2.75667L3.14917 7.5H5Z" fill="#0B0A23"/>
</svg>

 


  </div>
</router-link>


   <div class="d-flex align-items-center    " style="position:relative;padding-left:50px"  >
      
      <div style="position:absolute;left:0;height:20px;width:1px;background:#e8e9f1;opacity:0.4"></div>

      <p class="mya" style="color: #0B0A23;

opacity: 0.8;font-weight: 500;
font-size: 14px;" v-on:click='account'>My Account</p>

<div v-if='user' style="position:absolute;top:0px;left:50%;transform:translateX(-50%);padding-top:40px;cursor:pointer" class="opanav">


  <div style="width:170px;background:#fff;border-radius:4px;box-shadow:0 0 10px rgba(0,0,0,0.1)">

    <router-link to='/whishlist' style='text-decoration:none'>
    <p class="navhover" style="color: #0B0A23;opacity: 0.8;font-weight: 500;font-size: 14px;padding:10px ;border-bottom:1px solid #fafafa">Wishlist</p>
  </router-link>
   <router-link to='/account' style='text-decoration:none'>
       <p class="navhover" style="color: #0B0A23;opacity: 0.8;font-weight: 500;font-size: 14px;padding:10px ;border-bottom:1px solid #fafafa">Account</p>
     </router-link>
          <p class="navhover"   v-on:click='logout' style="color: #0B0A23;opacity: 0.8;font-weight: 500;font-size: 14px;padding:10px ;border-bottom:1px solid #fafafa">Logout</p>
  </div>
</div>


  </div>






</div>

</div>

  </div>
  
</div>





 
 
    <div class=" d-md-none d-block  " style="padding: 1px 14px 12px;background:#fff;width:100% ">


<div class="d-flex align-items-center  " style="margin-top:17px!important;margin-bottom:20px!important" >
   <router-link    to="$router.go(-1)"  style='text-decoration:none'>
  <svg width="21"   height="14" viewBox="0 0 21 14" style='cursor:pointer' fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M0.363604 6.3636C0.012132 6.71508 0.012132 7.28492 0.363604 7.6364L6.09117 13.364C6.44264 13.7154 7.01249 13.7154 7.36396 13.364C7.71543 13.0125 7.71543 12.4426 7.36396 12.0912L2.27279 7L7.36396 1.90883C7.71543 1.55736 7.71543 0.987511 7.36396 0.636039C7.01249 0.284567 6.44264 0.284567 6.09117 0.636039L0.363604 6.3636ZM1 7.9H21V6.1H1V7.9Z" fill="#0B0A23"/>
</svg>
</router-link>
<p  class="shopbag" style="margin-left:20px;margin-top:0px!important" >My Orders
</p>


</div>


      <div class="d-flex align-items-center justify-content-between mt-3">
    
              <p style="font-weight: 600;
font-size: 14px;
 


color: #0B0A23;" >Showing All orders</p>
              <div class="d-flex align-items-center" style="border: 1px solid #E0E1E9;padding:6px 12px;border-radius:5px;cursor:pointer" v-on:click='filterbox=true'>
                <i class='bx bx-filter filtericon' style="color:rgba(0, 0, 0, 70%)"  ></i>
                  <p style="color: rgba(11, 10, 35, 70%);font-weight:600;font-size:14px;margin-left:8px;text-transform: capitalize;
"  >{{filtertext}}</p>

              </div>
              </div>
       <div style="    height: 1px;
    background: rgba(217, 215, 234, 0.3);margin-top:17px" class=" d-md-none d-block"></div>

            </div>


<div style="background:#fff" class=" d-md-none d-flex">
  
            <div class="container" style="padding:0px;margin:0px">
                <div class="row" style="padding:0px;margin:0px;padding-top:0px"  >


                  <template v-for='(itm,index) in orders'>
                    
          <div   class="col-md-6 mb-0" style="padding:0px;margin:0px"  >

                      <router-link :to="'/orderdetails/'+itm.orderid" style='text-decoration:none'>

                    <div style="padding:10px 14px;">

                      <div style="border: 1px solid #efeff4;border-radius:5px;padding:20px;cursor:pointer;background:  rgba(239, 239, 245, 45%);
"> 
                            
                            <div class="d-flex align-items-center">
                              <div style="width:45px;overflow:hidden;border-radius:4px">

                              


                                <img :src="itm.items[0].imageurl[0]"  class="img-fluid" style="width:100%">
                              </div>
                              <div style="flex:1" class="d-flex align-items-center justify-content-between">
                                 
                                
                                 
                              </div>
                            </div>
                            <div class="d-flex align-items-center justify-content-between mt-3">
                                    <p class="actprice" style="font-size: 14px;
 font-weight:600;


color: #0B0A23;">Order #{{itm.orderid}}</p>
                                    <p  class="actprice" style="font-weight: 700;
font-size: 15px;
 

text-align: right;

color: #0B0A23;">₹{{itm.total}}</p>
                            </div>
                             <div class="d-flex align-items-center justify-content-between mt-1">
                                    <p class="actprice" style="font-size: 14px;
 font-weight:600;


color: #0B0A23;">{{itm.items.length}} item</p>
                                    <p  class="actprice" style="font-size: 14px;
font-weight:600;

text-align: right;

color: #0B0A23;

opacity: 0.7;">{{renderdate(itm.date)}}</p>
                            </div>


                      </div>
                        
                    </div>
                  </router-link>
                  </div>

                               </template>

 
                  
                </div>
            </div>
</div>




 




 


  </div>
  
</div>

 
 















 




<!--- header -->



<div v-if='filterbox' style="position:fixed;top:0;left:0;right:0;bottom:0;z-index:10000000000" class="d-flex  filterbox">
  <div style="position:absolute;top:0;left:0;right:0;bottom:0;background:rgba(0,0,0,0.3);z-index:100000" v-on:click='filterbox=false'></div>
  <div style="box-shadow:none!important"  class="actfilterbox">

   <div class="d-flex align-items-center justify-content-between  " style="margin-bottom:25px">
                <p style="font-size: 23px;
font-weight:700;


color: #0B0A23;">Filter</p>
                <i class='bx bx-x' style="color:#0B0A23;font-size:28px;cursor:pointer" v-on:click='filterbox=false'  ></i>
              </div>

    <template v-for='itm in filters'>
    <div v-if='itm.selected' class="d-flex align-items-center" style="cursor:pointer;margin-top:15px" v-on:click='filterorder(itm)'>
        <div style="width:22px;height:22px;position:relative;border-radius:50px;border:1px solid rgba(246, 74, 84, 0.9)">
          <div style="position:absolute;top:4px;right:4px;bottom:4px;left:4px;border-radius:50px;background:rgba(246, 74, 84, 0.9);opacity:0.9"  ></div>
        </div>
        <p style="margin-left:15px;color:#0B0A23;font-weight:600;font-size:16px;">{{itm.name}}</p>
      </div>
       <div v-else class="d-flex align-items-center" style="cursor:pointer;margin-top:15px" v-on:click='filterorder(itm)'>
        <div style="width:22px;height:22px;position:relative;border-radius:50px;border:1px solid rgba(166, 166, 192, 0.6)">
          <div style="position:absolute;top:4px;right:4px;bottom:4px;left:4px;border-radius:50px;background:rgba(255,255,255,0.5);opacity:0.9"  ></div>
        </div>
        <p style="margin-left:15px;color:#0B0A23;font-weight:500;font-size:16px;">{{itm.name}}</p>
      </div>
    </template>
    
  </div>
</div>

<!-- filters -->
 









 

<div  v-if='loadstatus && theme==3' >

</div>


<div  v-else-if='loadstatus && theme==2' >






 

</div>



<div v-else-if='loadstatus && theme==1' >




 

<div class="pt-md-4 pb-md-5 pt-4 pb-3  headerwrapper2  d-md-block d-none "  style="background:#fff!important">
  <div class="container pads " style="padding:0px">
  <div class="   ">




<div class="d-flex align-items-center mt-md-5 mb-md-5 mb-3 mt-md-3 mt-0 m17" >
  
  <svg width="21"  v-on:click="tab='bag'" height="14" viewBox="0 0 21 14" style='cursor:pointer' fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M0.363604 6.3636C0.012132 6.71508 0.012132 7.28492 0.363604 7.6364L6.09117 13.364C6.44264 13.7154 7.01249 13.7154 7.36396 13.364C7.71543 13.0125 7.71543 12.4426 7.36396 12.0912L2.27279 7L7.36396 1.90883C7.71543 1.55736 7.71543 0.987511 7.36396 0.636039C7.01249 0.284567 6.44264 0.284567 6.09117 0.636039L0.363604 6.3636ZM1 7.9H21V6.1H1V7.9Z" fill="#0B0A23"/>
</svg>
<p  class="shopbag" style="margin-left:20px;margin-top:0px!important" >My Orders
</p>


</div>


<div style="height:75vh" class="cartborder"   >
  


  <div class="container" style="padding:0px;margin:0px;height:100%">
    <div class="row" style="padding:0px;margin:0px;height:100%">
     

      <div class="col-md-12" style="padding:0px;margin:0px;height:100%">


    

        <div style="height:100%;padding:30px;overflow:scroll;padding-top:0px" v-if="tab=='myorders'">
            <div class="d-flex align-items-center justify-content-between" style="padding-top:30px;padding-bottom:30px;position:sticky;top:0;background:#fff;z-index:100000000">
              <p style="font-weight: 700;
font-size: 16px;
 


color: #0B0A23;
">Showing All orders</p>
              <div class="d-flex align-items-center" style=" border: 1px solid #E0E1E9;padding:4px 8px;border-radius:4px;cursor:pointer" v-on:click='filterbox=true'>
                <i class='bx bx-filter' style="font-size:25px"></i>
                  <p style="margin-left:8px;font-size:16px;font-weight:500;margin-bottom:0px;color:#1a181e;text-transform: capitalize; ">Filters</p>

              </div>
            </div>


            <div class="container" style="padding:0px;margin:0px">
                <div class="row" style="padding:0px;margin:0px"  >


                  <template v-for='(itm,index) in orders'>
                    
     
                  <div v-if='!(index % 2 == 0)' class="col-md-6 mb-4" style="padding:0px;margin:0px"  >

                      <router-link :to="'/orderdetails/'+itm.orderid" style='text-decoration:none'>

                    <div style="padding-left:10px;">

                      <div style="border: 1px solid #efeff4;border-radius:5px;padding:20px;cursor:pointer;background:  rgba(239, 239, 245, 45%);
"> 
                            
                            <div class="d-flex align-items-center">
                              
                              <div style="flex:1" class="d-flex align-items-center justify-content-between">
                                 
                                
                                 <div  v-if="itm.status=='pending'"  style="background:#F7B744;padding:8px 16px;border-radius:3px;">
                                   <p style="color:#fff;font-size:12px;font-weight:600;">{{itm.status}}</p>
                                 </div>
                                  <div  v-else-if="itm.status=='Accepted'"  style="background:#53B42D;padding:8px 16px;border-radius:3px;">
                                   <p style="color:#fff;font-size:12px;font-weight:600;">{{itm.status}}</p> 
                                 </div>
                                    <div  v-else-if="itm.status=='Shipped'"  style="background:#EE7438;padding:8px 16px;border-radius:3px;">
                                   <p style="color:#fff;font-size:12px;font-weight:600;">{{itm.status}}</p>
                                 </div>
                                  <div  v-else-if="itm.status=='Delivered'"  style="background:#19B959;padding:8px 16px;border-radius:3px;">
                                   <p style="color:#fff;font-size:12px;font-weight:600;">{{itm.status}} </p>
                                 </div>
                                  <div  v-else-if="itm.status=='Cancelled'"  style="background:#FC1A27;padding:8px 16px;border-radius:3px;">
                                   <p style="color:#fff;font-size:12px;font-weight:600;">{{itm.status}}</p>
                                 </div>
                                   <div  v-else-if="itm.status=='Not Delivered'"  style="background:#FC1A27;padding:8px 16px;border-radius:3px;">
                                   <p style="color:#fff;font-size:12px;font-weight:600;">{{itm.status}}</p>
                                 </div>
                                   <div  v-else-if="itm.status=='Rejected'"  style="background:#FC1A27;padding:8px 16px;border-radius:3px;">
                                   <p style="color:#fff;font-size:12px;font-weight:600;">{{itm.status}}</p>
                                 </div>
                              </div>
                            </div>
                            <div class="d-flex align-items-center justify-content-between mt-3">
                                    <p class="actprice" style="font-size: 12px;
 font-weight:500;


color: #0B0A23;">Order #{{itm.orderid}}</p>
                                    <p  class="actprice" style="font-weight: 600;
font-size: 15px;
 

text-align: right;

color: #0B0A23;">₹{{itm.total}}</p>
                            </div>
                             <div class="d-flex align-items-center justify-content-between mt-1">
                                    <p class="actprice" style="font-size: 12px;
 font-weight:500;


color: #0B0A23;">{{itm.items.length}} item</p>
                                    <p  class="actprice" style="font-size: 13px;
font-weight:400;

text-align: right;

color: #0B0A23;

opacity: 0.7;">{{renderdate(itm.date)}}</p>
                            </div>


                      </div>
                        
                    </div>
                  </router-link>
                  </div>



                       <div v-else class="col-md-6 mb-4" style="padding:0px;margin:0px"  >

                      <router-link :to="'/orderdetails/'+itm.orderid" style='text-decoration:none'>

                    <div style="padding-right:10px;">

                      <div style="border: 1px solid #efeff4;border-radius:5px;padding:20px;cursor:pointer;background:  rgba(239, 239, 245, 45%);
"> 
                            
                            <div class="d-flex align-items-center">
                              
                              <div style="flex:1" class="d-flex align-items-center justify-content-between">
                               
                                
                                 <div  v-if="itm.status=='pending'"  style="background:#F7B744;padding:8px 16px;border-radius:3px;">
                                   <p style="color:#fff;font-size:12px;font-weight:600;">{{itm.status}}</p>
                                 </div>
                                  <div  v-else-if="itm.status=='Accepted'"  style="background:#53B42D;padding:8px 16px;border-radius:3px;">
                                   <p style="color:#fff;font-size:12px;font-weight:600;">{{itm.status}}</p> 
                                 </div>
                                    <div  v-else-if="itm.status=='Shipped'"  style="background:#EE7438;padding:8px 16px;border-radius:3px;">
                                   <p style="color:#fff;font-size:12px;font-weight:600;">{{itm.status}}</p>
                                 </div>
                                  <div  v-else-if="itm.status=='Delivered'"  style="background:#19B959;padding:8px 16px;border-radius:3px;">
                                   <p style="color:#fff;font-size:12px;font-weight:600;">{{itm.status}} </p>
                                 </div>
                                  <div  v-else-if="itm.status=='Cancelled'"  style="background:#FC1A27;padding:8px 16px;border-radius:3px;">
                                   <p style="color:#fff;font-size:12px;font-weight:600;">{{itm.status}}</p>
                                 </div>
                                   <div  v-else-if="itm.status=='Not Delivered'"  style="background:#FC1A27;padding:8px 16px;border-radius:3px;">
                                   <p style="color:#fff;font-size:12px;font-weight:600;">{{itm.status}}</p>
                                 </div>
                                   <div  v-else-if="itm.status=='Rejected'"  style="background:#FC1A27;padding:8px 16px;border-radius:3px;">
                                   <p style="color:#fff;font-size:12px;font-weight:600;">{{itm.status}}</p>
                                 </div>
                              </div>
                            </div>
                            <div class="d-flex align-items-center justify-content-between mt-3">
                                    <p class="actprice" style="font-size: 12px;
 font-weight:500;


color: #0B0A23;">Order #{{itm.orderid}}</p>
                                    <p  class="actprice" style="font-weight: 600;
font-size: 15px;
 

text-align: right;

color: #0B0A23;">₹{{itm.total}}</p>
                            </div>
                             <div class="d-flex align-items-center justify-content-between mt-1">
                                    <p class="actprice" style="font-size: 12px;
 font-weight:500;


color: #0B0A23;">{{itm.items.length}} item</p>
                                    <p  class="actprice" style="font-size: 13px;
font-weight:400;

text-align: right;

color: #0B0A23;

opacity: 0.7;">{{renderdate(itm.date)}}</p>
                            </div>


                      </div>
                        
                    </div>
                  </router-link>
                  </div>


 

                               </template>

 
                  
                </div>
            </div>





        </div>
      </div>
    </div>
  </div>
 
</div>





 



 
 </div>

  </div>
  
</div>
 

 </div>
 <div  v-else >



    <div  style="height:calc(100vh - 94px);background:#fff; " class="d-md-flex d-none align-items-center justify-content-center">
 
   <div style="width:100px;">
     <img src="https://firebasestorage.googleapis.com/v0/b/makeashops.appspot.com/o/Ellipsis-2.6s-200px%20(1).gif?alt=media&token=5e688bc8-00a4-425c-a8cc-e8f7079f2730" class="img-fluid" style="width:100%">
   </div>
 </div>




    <div  style="height:calc(100vh - 54px);background:#fff; " class="d-md-none d-flex align-items-center justify-content-center">
   
   <div style="width:80px;">
     <img src="https://firebasestorage.googleapis.com/v0/b/makeashops.appspot.com/o/Ellipsis-2.6s-200px%20(1).gif?alt=media&token=5e688bc8-00a4-425c-a8cc-e8f7079f2730" class="img-fluid" style="width:100%">
   </div>
 </div>





 

      </div>

 


 


 














  



<!--footer -->

 




 
 
  </div>
</div>
</div>
</template>

<script>
 
  import firebase from 'firebase'


 const fb = require('./firebaseconfig.js')
 
export default {
         props: ['loadstatus','info','carts','theme'],

  
  data () {

        return{


            user:false,
            addrnames:'',
            addrmobile:'',
            addrpincode:'',
            addrcity:'',
            filtertext:'All orders',
            deletebox:false,
             sendotpclicked:false,
       otpenterd:true,
       otpvalue:'',
            addraddress:'',
            emptydata:false,
            tab:'myorders',
            addbox:false,
            orders:[],
            orderss:[],
            edit:false,
            docid:null,
            address:[],
            filterbox:false,
            loginbox:false,
            filters:[
            {
              name:'All orders',
              selected:true
            },
            {
              name:'Active orders',
              selected:false,
            },
            {
              name:'Completed orders',
              selected:false,
            },
            {
              name:'Failed orders',
              selected:false,
            },
            ]


        }
     
    
  },
  created(){
 
 
      if(firebase.auth().currentUser){




var vm=this

var address=[]

 fb.db.collection('client5').doc(firebase.auth().currentUser.uid).collection('address').orderBy('date','desc').onSnapshot(querySnapshot=>{
 address=[]
    querySnapshot.forEach((doc)=> {
      
 
      address.push({id:doc.id,...doc.data()})
        
    })
 
 

vm.address=[
...address
]


})


var z=[]

     fb.db.collection('client5').doc(firebase.auth().currentUser.uid).collection('orders').orderBy('date','desc').onSnapshot(querySnapshot=>{
 z=[]
    querySnapshot.forEach((doc)=> {
      
 
      z.push({id:doc.id,...doc.data()})
        
    })
 
 

 
    vm.orders=[

    ...z

    ]

 

    vm.orderss=[

    ...z

    ]

 

 vm.loadtest=true
 if(vm.orders.length>0){
vm.emptydata=false
 }else{
   vm.emptydata=true
 }

 
 


  })





  this.user=true
 }else{

    this.user=false
 }



   },
   computed:{
 rendercartlength(){

var cartlength=0
        var x=this.carts.forEach((itm)=>{

           cartlength=Number(itm.quantity)+cartlength
        })
        return cartlength

    },
   },
   methods:{

async signout(){
  await firebase.auth().signOut()

  this.$router.push({ path: '/'  })

},
    async finaldelete(){
         await fb.db.collection('client5').doc(firebase.auth().currentUser.uid).collection('address').doc(this.docid).delete()

         this.deletebox=false
    },
    deleteaddress(item){
 

        this.deletebox=true

        this.docid=item.id

 

 


    },
    editaddress(item){


var vm=this
         this.edit=true
        this.docid=item.id

 
  vm.addrnames=item.name
 
  vm.addrmobile=item.mobile
 vm.addrpincode=item.pincode
   vm.addrcity=item.city
 vm.addraddress=item.address

vm.addbox=true



    },
   async addaddress(){


var vm=this
    if(this.edit){
 
 


 await fb.db.collection('client5').doc(firebase.auth().currentUser.uid).collection('address').doc(vm.docid).update({

  name:vm.addrnames,
  mobile:vm.addrmobile,
  pincode:vm.addrpincode,
  city:vm.addrcity,
  address:vm.addraddress,
  date:new Date()

 })



 vm.addrnames=''
  vm.addrmobile=''
 vm.addrpincode=''
   vm.addrcity=''
 vm.addraddress=''

 vm.addbox=false
   this.edit=false
        this.docid=null




         }else{




      var vm=this
 

 

 await fb.db.collection('client5').doc(firebase.auth().currentUser.uid).collection('address').add({

  name:vm.addrnames,
  mobile:vm.addrmobile,
  pincode:vm.addrpincode,
  city:vm.addrcity,
  address:vm.addraddress,
  date:new Date()

 })



 vm.addrnames=''
  vm.addrmobile=''
 vm.addrpincode=''
   vm.addrcity=''
 vm.addraddress=''

 vm.addbox=false





    }
    },
    closeaddbox(){
      this.addbox=false

    },
    filterorder(item){
var text=''

var y=this.filters.map((itms)=>{

  if(item.name==itms.name){
    text=itms.name
    return {
      ...itms,
      selected:true
    }
  }else{
     return {
      ...itms,
      selected:false
    }
  }
})
     

if(item.name=='All orders'){


 var x=[
 ...this.orderss
 ]

}
else if(item.name=='Completed orders'){

   var x=this.orderss.filter((itm)=>{

          return itm.status=='Delivered' 
 })
}
else if(item.name=='Active orders'){

   var x=this.orderss.filter((itm)=>{

          return itm.status=='Accepted'|| itm.status=='pending' || itm.status=='Shipped'

 })
}
else{
 var x=this.orderss.filter((itm)=>{

          return itm.status=='Rejected'|| itm.status=='Cancelled' || itm.status=='Not Delivered'

 })

}
 
 

 this.filtertext=text
 
      this.orders=[
      ...x
      ]
      this.filters=[
      ...y
      ]

      this.filterbox=false

    },

  account(){


     if(firebase.auth().currentUser){

//alert('yes')


this.$router.push({ path: '/account' })

 }else{
this.loginbox=true
 }
    },
    
     renderdate(timestamp){

      var date=timestamp.toDate();
      var stringdate=date.getDate()+'/'+date.getMonth()+'/'+date.getFullYear()
      var today=new Date()
      var stringtoday=today.getDate()+'/'+today.getMonth()+'/'+today.getFullYear()
      var yesterday=new Date()
      yesterday.setDate(yesterday.getDate() - 1);


      var stringyesterdayday=yesterday.getDate()+'/'+yesterday.getMonth()+'/'+yesterday.getFullYear()
 
 

if(stringdate==stringtoday){
 
 return 'Today, '+ date.toLocaleString('en-US', { hour: 'numeric', minute: 'numeric', hour12: true })
 
}else if(stringyesterdayday==stringdate){

 
 return 'Yesterday, '+date.toLocaleString('en-US', { hour: 'numeric', minute: 'numeric', hour12: true })

   
}else{

return stringdate+', '+date.toLocaleString('en-US', { hour: 'numeric', minute: 'numeric', hour12: true })

}

     

    },

  
      logout(){
        var vm=this

        fb.auth.signOut().then(function() {
 
vm.user=false
vm.$router.push({ path: '/' })

}).catch(function(error) {
 
});
      }
   }


   
    
 
  
}
</script>
<style scoped >
 

</style>
 



// WEBPACK FOOTER //
// src/ordersmob.vue